import installmentsAPI, { type RatesRequest, type RatesResponse } from '@api/installments'
import { makeLoader } from '@lib/loader'

export const useInstallmentRates = makeLoader<RatesRequest, RatesResponse>({
  key: 'installment-rates',
  loader: installmentsAPI.rates,
})
